/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIPaginatedRoleList,
  APIRole,
} from '../models/index';
import {
    APIPaginatedRoleListFromJSON,
    APIPaginatedRoleListToJSON,
    APIRoleFromJSON,
    APIRoleToJSON,
} from '../models/index';

export interface V1AccountsUsersRolesListRequest {
    userPk: string;
    page?: number;
    pageSize?: number;
}

export interface V1AccountsUsersRolesRetrieveRequest {
    id: number;
    userPk: string;
}

/**
 * 
 */
export class AccountsuserRoleApi extends runtime.BaseAPI {

    /**
     */
    async v1AccountsUsersRolesListRaw(requestParameters: V1AccountsUsersRolesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedRoleList>> {
        if (requestParameters['userPk'] == null) {
            throw new runtime.RequiredError(
                'userPk',
                'Required parameter "userPk" was null or undefined when calling v1AccountsUsersRolesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{user_pk}/roles/`.replace(`{${"user_pk"}}`, encodeURIComponent(String(requestParameters['userPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedRoleListFromJSON(jsonValue));
    }

    /**
     */
    async v1AccountsUsersRolesList(requestParameters: V1AccountsUsersRolesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedRoleList> {
        const response = await this.v1AccountsUsersRolesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async v1AccountsUsersRolesRetrieveRaw(requestParameters: V1AccountsUsersRolesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIRole>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1AccountsUsersRolesRetrieve().'
            );
        }

        if (requestParameters['userPk'] == null) {
            throw new runtime.RequiredError(
                'userPk',
                'Required parameter "userPk" was null or undefined when calling v1AccountsUsersRolesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/accounts/users/{user_pk}/roles/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"user_pk"}}`, encodeURIComponent(String(requestParameters['userPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIRoleFromJSON(jsonValue));
    }

    /**
     */
    async v1AccountsUsersRolesRetrieve(requestParameters: V1AccountsUsersRolesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIRole> {
        const response = await this.v1AccountsUsersRolesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
